module.exports = __webpack_public_path__ + "static/media/material-help.fc34ca28.svg";